import { render, staticRenderFns } from "./CommunityISO.vue?vue&type=template&id=34513e45&scoped=true&"
import script from "./CommunityISO.vue?vue&type=script&lang=js&"
export * from "./CommunityISO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34513e45",
  null
  
)

export default component.exports